import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getWorkflowCase,
  listWorkflowCases,
  updateSubStepApprovalNote,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 承認メモを編集・削除する mutation hook (spec AC-WFW-007a/d)。
 * onSuccess で detail + list query を invalidate する。
 */
export function useUpdateSubStepApprovalNote(
  caseId: string,
): InvalidatingMutationResultFor<typeof updateSubStepApprovalNote> {
  return useInvalidatingMutation(updateSubStepApprovalNote, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
